<div class="flex" [class.justify-center]="alignment() === 'center'">
  <div
    class="inline-flex items-center bg-lime-300 rounded-sm py-1"
    [class.px-1.5]="variation() === 'default'"
    [class.px-2]="variation() === 'hero'"
    cdkOverlayOrigin
    #hubOrigin="cdkOverlayOrigin"
    (focus)="setIsShowTooltipFocused(true)"
    (blur)="setIsShowTooltipFocused(false)"
    (mouseenter)="setIsShowTooltipHovered(true)"
    (mouseleave)="setIsShowTooltipHovered(false)"
    tabindex="0"
  >
    <app-icon-approval-thumb
      class="shrink-0"
      [class]="thumbIconMarginClass()"
      color="#064E3B"
      [width]="thumbIconWidth()"
      [height]="thumbIconHeight()"
    ></app-icon-approval-thumb>
    <span
      class="approval-chance__label text-green-900 leading-none whitespace-nowrap mr-1"
      [class.be-hint-bold]="variation() === 'default'"
      [class.be-body-s-bold]="variation() === 'hero'"
    >
      {{ approval() | titlecase }} chance of approval
    </span>
    <app-icon-info-outline
      class="shrink-0"
      color="#064E3B"
      [width]="infoIconWidth()"
      [height]="infoIconHeight()"
    ></app-icon-info-outline>

    <ng-template
      cdk-connected-overlay
      [cdkConnectedOverlayOrigin]="hubOrigin"
      [cdkConnectedOverlayOpen]="isShowTooltipFocused || isShowTooltipHovered"
      [cdkConnectedOverlayHasBackdrop]="false"
      [cdkConnectedOverlayPush]="false"
      [cdkConnectedOverlayLockPosition]="true"
      [cdkConnectedOverlayFlexibleDimensions]="false"
      [cdkConnectedOverlayGrowAfterOpen]="false"
      [cdkConnectedOverlayViewportMargin]="0"
      [cdkConnectedOverlayOffsetX]="0"
      [cdkConnectedOverlayOffsetY]="direction() === 'down' ? 8 : 12"
      [cdkConnectedOverlayPositions]="[
        {
          originX: 'center',
          originY: direction() === 'down' ? 'bottom' : 'top',
          overlayX: 'center',
          overlayY: direction() === 'down' ? 'top' : 'bottom',
          offsetX: 0,
        },
      ]"
    >
      <app-be-tooltip
        class="max-w-[504px]"
        @fadeInOut
        [direction]="direction()"
        id="autoPayTooltip"
        (mouseenter)="setIsShowTooltipHovered(true)"
        (mouseleave)="setIsShowTooltipHovered(false)"
      >
        <p class="be-text-xs whitespace-normal normal-case text-white m-0">
          {{ disclosure() }}
        </p>
      </app-be-tooltip>
    </ng-template>
  </div>
</div>
